import { getImage } from '@dazn/lp-web/src/utils/commonUtils';
import { ICompetitionCarousel } from '@dazn/lp-web/src/types';

export function competitionCarouselProxy(component: any): ICompetitionCarousel {
    const title = component?.fields?.title;
    const carouselInterval = component?.fields?.carouselInterval;
    const componentType = component?.fields?.componentType;
    const competitions = component?.fields?.entries?.map((entry: any) => {
        const description = entry?.fields?.description;
        const isHighlighted = entry?.fields?.isHighlighted;
        const logo = getImage(entry?.fields?.image);
        return {
            description,
            isHighlighted,
            logo
        };
    });

    return {
        title,
        componentType,
        competitions,
        carouselInterval
    };
}
